import React from 'react';
import { AsyncDispatch } from '../../../types/global';
import { fetchScriptLogs } from '../../actions/distribution_apisettings';
import AutomationLogs from '../../components/body/distribution/AutomationLogs';
import { useAppDispatch } from '../../store/ReduxStore';

const AutomationLogsContainer: React.FC = () => {
  const dispatch: AsyncDispatch = useAppDispatch();

  React.useEffect(() => {
    dispatch(fetchScriptLogs());
  }, [dispatch]);

  const fetchNextScriptLogs = (page: number) => {
    return dispatch(fetchScriptLogs(page));
  };

  return <AutomationLogs fetchNextScriptLogs={fetchNextScriptLogs} />;
};

export default AutomationLogsContainer;
